import {
  isNumberPositive,
  isNumberPositiveAndLessThan,
  isNumberPositiveAndMoreThan,
} from 'utils/numbers';
import { isValueInArray } from 'utils/array';
import loadConstants from 'utils/loads/constants';

const validationsPerOrderType = {
  total_weight: {
    DEFAULT: ({ value, additionalData }) => {
      return isNumberPositiveAndLessThan(
        value,
        additionalData.settings?.maximum_truck_weight
      );
    },
    CATALOG: ({ value, additionalData }) => {
      return true;
    },
  },
  [loadConstants.FIELDS.ITEM_WIDTH]: {
    DEFAULT: ({ value }) => {
      return (
        isNumberPositiveAndLessThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_WIDTH].MAX
        ) &&
        isNumberPositiveAndMoreThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_WIDTH].MIN
        )
      );
    },
    CATALOG: ({ value, additionalData }) => {
      return (
        isNumberPositiveAndLessThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_WIDTH].MAX
        ) &&
        isNumberPositiveAndMoreThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_WIDTH].MIN
        )
      );
    },
  },
  [loadConstants.FIELDS.ITEM_HEIGHT]: {
    DEFAULT: ({ value }) => {
      return (
        isNumberPositiveAndLessThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_HEIGHT].MAX
        ) &&
        isNumberPositiveAndMoreThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_HEIGHT].MIN
        )
      );
    },
    CATALOG: ({ value, additionalData }) => {
      return true;
    },
  },
  [loadConstants.FIELDS.ITEM_LENGTH]: {
    DEFAULT: ({ value }) => {
      return (
        isNumberPositiveAndLessThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_LENGTH].MAX
        ) &&
        isNumberPositiveAndMoreThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_LENGTH].MIN
        )
      );
    },
    CATALOG: ({ value, additionalData }) => {
      return (
        isNumberPositiveAndLessThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_LENGTH].MAX
        ) &&
        isNumberPositiveAndMoreThan(
          value,
          loadConstants.FIELDS_CONFIG[loadConstants.FIELDS.ITEM_LENGTH].MIN
        )
      );
    },
  },
  number_of_items: {
    DEFAULT: ({ value }) => {
      return isNumberPositive(value);
    },
    CATALOG: ({ value, additionalData }) => {
      return isNumberPositive(value);
    },
  },
  pallet_type: {
    DEFAULT: ({ value }) => {
      const palletTypesValues = Object.keys(loadConstants.PALLET_TYPES).map(
        (key) => loadConstants.PALLET_TYPES[key]
      );
      const allowedPalletTypes = ['', ...palletTypesValues];
      return isValueInArray(value, allowedPalletTypes);
    },
    CATALOG: ({ value, additionalData }) => {
      return true;
    },
  },
  load_type: {
    DEFAULT: ({ value }) => {
      const allowedLoadTypes = [
        loadConstants.LOAD_TYPES.PALLET,
        loadConstants.LOAD_TYPES.BULK,
        loadConstants.LOAD_TYPES.PARCEL,
      ];
      return isValueInArray(value, allowedLoadTypes);
    },
    CATALOG: ({ value, additionalData }) => {
      return true;
    },
  },
  type_of_goods: {
    DEFAULT: ({ value }) => {
      return true;
    },
  },
};

function validateLoadInput({
  field,
  value,
  settings,
  orderType,
  load,
  validations = {},
}) {
  const fieldValidationPerOrderType = validationsPerOrderType[field];

  if (!fieldValidationPerOrderType) {
    return { isValid: true, error: field };
  }

  const fieldValidation =
    fieldValidationPerOrderType[orderType] ||
    fieldValidationPerOrderType.DEFAULT;

  const isValid = fieldValidation({
    value,
    additionalData: {
      load,
      settings,
      validations,
    },
  });

  return { isValid, ...(!isValid ? { error: field } : {}) };
}

export default validateLoadInput;
